import { createAction, props } from '@ngrx/store';
import { AllocationGroup, InventoryAllocation } from '../../interfaces/allocation-group';

// User (global) allocation groups
export const fetchUserAllocationGroups = createAction(
  '[Inventory Allocations] Fetch User Allocation Groups'
);

export const fetchUserAllocationGroupsSuccess = createAction(
  '[Inventory Allocations API] Fetch User Allocation Groups Success',
  props<{ groups: AllocationGroup[] }>()
);

export const fetchUserAllocationGroupsFailure = createAction(
  '[Inventory Allocations API] Fetch User Allocation Groups Failure'
);

// Product allocations, keyed by productId
export const fetchProductAllocations = createAction(
  '[Inventory Allocations] Fetch Product Allocations',
  props<{ productId: number }>()
);

export const fetchProductAllocationsSuccess = createAction(
  '[Inventory Allocations API] Fetch Product Allocations Success',
  props<{ productId: number; allocations: InventoryAllocation[] }>()
);

export const fetchProductAllocationsFailure = createAction(
  '[Inventory Allocations API] Fetch Product Allocations Failure',
  props<{ productId: number }>()
);

export const resetProductAllocations = createAction(
  '[Inventory Allocations API] Reset Product Allocations',
  props<{ productId: number }>()
);

// Product allocations for many products at once - the list view configures a whole page of GAI
// items, and one request per row would be one request per visible product.
export const fetchProductsAllocations = createAction(
  '[Inventory Allocations] Fetch Products Allocations',
  props<{ productIds: number[] }>()
);

// The map carries an entry for every requested product, including the ones the response left out:
// a product with no entry has no groups to offer, and the dropdown has to say so rather than
// spin forever on a fetch that never resolves.
export const fetchProductsAllocationsSuccess = createAction(
  '[Inventory Allocations API] Fetch Products Allocations Success',
  props<{ allocationsByProductId: Record<number, InventoryAllocation[]> }>()
);

export const fetchProductsAllocationsFailure = createAction(
  '[Inventory Allocations API] Fetch Products Allocations Failure',
  props<{ productIds: number[] }>()
);
